<template>
  <div class="claim-product-info">
    <div class="id-sn-container">
      <Typography v-if="claim.productId" variant="body-2"
        >Product ID: {{ claim.productId }}</Typography
      >
      <Typography v-if="claim.serialNumber" variant="body-2"
        >SN: {{ claim.serialNumber }}</Typography
      >
    </div>
    <Typography v-if="includeDescription && claim.productDescription" variant="body-2"
      >Product Description: {{ claim.productDescription }}</Typography
    >
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";

export default {
  name: "ClaimProductInfo",
  components: {
    Typography,
  },
  props: {
    claim: {
      type: Object,
      required: true,
    },
    includeDescription: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.claim-product-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.id-sn-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}
</style>
